import { render, staticRenderFns } from "./Funerarias.vue?vue&type=template&id=5071b0c7&"
import script from "./Funerarias.vue?vue&type=script&lang=js&"
export * from "./Funerarias.vue?vue&type=script&lang=js&"
import style0 from "./Funerarias.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports